// extracted by mini-css-extract-plugin
export default {"tcoButton":"ImnHw1"};